import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
interface CountryWiseReportProps {
  dateRange: {
    from: string;
    to: string;
  };
}
const CountryWiseReport: React.FC<CountryWiseReportProps> = ({
  dateRange
}) => {
  // Mock data for the report
  const countryData = [{
    country: 'United Arab Emirates',
    transactions: 245,
    amount: 1225000
  }, {
    country: 'Saudi Arabia',
    transactions: 180,
    amount: 900000
  }, {
    country: 'United Kingdom',
    transactions: 120,
    amount: 840000
  }, {
    country: 'United States',
    transactions: 95,
    amount: 665000
  }, {
    country: 'Qatar',
    transactions: 75,
    amount: 375000
  }, {
    country: 'Kuwait',
    transactions: 60,
    amount: 300000
  }];
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  };
  return <div data-id="element-2274">
      <div className="mb-4 p-3 bg-blue-50 border border-blue-100 rounded-md" data-id="element-2275">
        <h3 className="text-sm font-medium text-blue-800" data-id="element-2276">Report Parameters</h3>
        <p className="text-xs text-blue-600 mt-1" data-id="element-2277">
          Date Range: {dateRange.from} to {dateRange.to}
        </p>
      </div>
      <div className="mb-6" style={{
      height: 300
    }} data-id="element-2278">
        <ResponsiveContainer width="100%" height="100%" data-id="element-2279">
          <BarChart data={countryData} margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5
        }} data-id="element-2280">
            <CartesianGrid strokeDasharray="3 3" data-id="element-2281" />
            <XAxis dataKey="country" data-id="element-2282" />
            <YAxis yAxisId="left" orientation="left" stroke="#8884d8" data-id="element-2283" />
            <YAxis yAxisId="right" orientation="right" stroke="#82ca9d" data-id="element-2284" />
            <Tooltip formatter={(value, name) => {
            if (name === 'amount') return formatCurrency(Number(value));
            return value;
          }} data-id="element-2285" />
            <Legend data-id="element-2286" />
            <Bar yAxisId="left" dataKey="transactions" name="Transactions" fill="#8884d8" data-id="element-2287" />
            <Bar yAxisId="right" dataKey="amount" name="Amount (USD)" fill="#82ca9d" data-id="element-2288" />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="overflow-x-auto" data-id="element-2289">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-2290">
          <thead className="bg-gray-50" data-id="element-2291">
            <tr data-id="element-2292">
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2293">
                Country
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2294">
                Transactions
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2295">
                Amount
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2296">
                Percentage
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-2297">
            {countryData.map(item => <tr key={item.country} className="hover:bg-gray-50" data-id="element-2298">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-2299">
                  {item.country}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2300">
                  {item.transactions}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2301">
                  {formatCurrency(item.amount)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2302">
                  {(item.amount / countryData.reduce((sum, data) => sum + data.amount, 0) * 100).toFixed(2)}
                  %
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
      <div className="mt-4 p-3 bg-gray-50 border border-gray-200 rounded-md" data-id="element-2303">
        <div className="flex justify-between items-center" data-id="element-2304">
          <span className="text-sm font-medium text-gray-700" data-id="element-2305">
            Total Transactions:{' '}
            {countryData.reduce((sum, data) => sum + data.transactions, 0)}
          </span>
          <span className="text-sm font-medium text-gray-700" data-id="element-2306">
            Total Amount:{' '}
            {formatCurrency(countryData.reduce((sum, data) => sum + data.amount, 0))}
          </span>
        </div>
      </div>
    </div>;
};
export default CountryWiseReport;